































































































import settings from '@/settings.coffee'
import gql from '@/gqlService.coffee'
import q from '@/gql/queries.coffee'
import mutations from '@/gql/mutations.coffee'
import moment from "moment"

export default {
    "name": "ImportReport"
    "props": {
        "msg": false
    }
    "computed":{}
    "methods":
        "sum_details": (mkey, details)->
            res = 0
            for plt in details
                if mkey?
                    res += plt.info[mkey]
                else
                    res += plt.info["ERROR"] + plt.info["WARNING"] + plt.info["too_old"] + plt.info["created"] + plt.info["modified"]
            return res
        "get_admin_url": (filter, platform)->
            #http://127.0.0.1:8012/admin/review/importreportline/?import_report=30796010-9937-41aa-a26e-db729053752d&level__exact=warning&o=1
            url = settings.backendUrl + "/admin/review/importreportline/?o=1&import_report="
            url += this.msg.uid
            if platform != undefined and platform != null and platform != "null"
                url += "&platform="
                url += platform
            if filter == "ERROR"
                url += "&level__exact=error"
            if filter == "WARNING"
                url += "&level__exact=warning"
            if filter == "too_old"
                url += "&title=review+too+old"
            if filter == "created"
                url += "&title=review+created"
            if filter == "modified"
                url += "&title=review+modified"
            return url
        "get_url": (filename)->
            return settings.backendMediaUrl+filename.replaceAll(":", '')
        "isOlderThanDays": (days, isoDate)->
            d = moment(isoDate)
            now = moment()
            return now.diff(d, 'days') > days
        "openBox": ()->
            self = this
            this.opened = not this.opened
            if not this.opened
                return
            this.loading = true 
            data = await q.run("get_importreportline_set", [this.msg.uid])
            by_platform = {}
            lines = data.body.data.importreportline_set
            #console.log(lines)
            for l in lines
                #console.log(l, l.platform in Object.keys(by_platform))
                if not(l.platform in Object.keys(by_platform))
                    by_platform[l.platform] = {
                        'ERROR': 0,
                        'WARNING': 0,
                        'created': 0,
                        'modified': 0,
                        'exists': 0,
                        'too_old': 0
                    }
                if l.level == "ERROR"
                    by_platform[l.platform]['ERROR'] += 1
                else if l.level == "WARNING"
                    by_platform[l.platform]['WARNING'] += 1
                else if l.level == "INFO" and l.title == "review created"
                    by_platform[l.platform]['created'] += 1
                else if l.level == "INFO" and l.title == "review modified"
                    by_platform[l.platform]['modified'] += 1
                else if l.level == "INFO" and l.title == "review too old"
                    by_platform[l.platform]['too_old'] += 1

            data2 = await q.run("get_last_review_by_platform", [])
            console.log("data2", data2.body.data.last_review_by_platform)
                                
            details = []
            for plat in Object.keys(by_platform).sort()
                last_review = null
                for r in data2.body.data.last_review_by_platform
                    # console.log(plat, r)
                    if r and r.platform.slug == plat
                        last_review = r.created_on
                console.log(last_review, plat)
                details.push({
                    "platform": plat,
                    "info": by_platform[plat],
                    "last_review": last_review
                })

            

            self.details = details
            self.loading = false
                

    "data":()->
        {
            "opened": false,
            "loading": false,
            "details": []
        }
}
